// extracted by mini-css-extract-plugin
export default {"inputSuffix":"Field__inputSuffix___HvdC2","inputSuffixContent":"Field__inputSuffixContent___matdN"};